/**
 * Copyright 2024 Design Barn Inc.
 */

import type { ReadonlyURLSearchParams } from 'next/navigation';

export const getFormattedSearchParamsString = (searchParams?: ReadonlyURLSearchParams): string => {
  const params = [];

  const entries = searchParams ? searchParams.entries() : null;

  if (!entries) {
    return '';
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of entries) {
    params.push(`${key}=${encodeURIComponent(value)}`);
  }

  const paramString = `?${params.join(`&`)}`;

  return paramString;
};
